import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-circular-progressbar',
  templateUrl: './circular-progressbar.component.html',
  styleUrls: ['./circular-progressbar.component.scss'],
})
export class CircularProgressbarComponent implements OnInit {
  @Input() maxPoint: number;
  @Input() minPoint: number;
  @Input() isLoading: boolean;
  progressBarStyle: string;
  animatePercent: number;

  targetNumber: number;
  currentNumber = 0;
  duration = 300;
  interval = 1;
  increment: number;
  animation: any;

  constructor() {}

  ngOnInit() {
    this.targetNumber = this.minPoint / this.maxPoint;
    this.increment = (this.targetNumber - this.currentNumber) * (this.interval / this.duration);

    if (!this.isLoading) {
      this.startAnimation();
    }
  }

  startAnimation() {
    this.animation = setInterval(() => {
      this.currentNumber += this.increment;
      this.progressBarStyle = `conic-gradient(var(--ion-color-primary) calc(${this.currentNumber} * 360deg), #dedede 0deg)`;
      if (this.currentNumber >= this.targetNumber) {
        clearInterval(this.animation);
      }
    }, this.interval);
  }
}
